import { DataTableHeader } from '../../../../../../core/components/Table/types/DataTableHeader';

export type TableDataTypes = {
  headers: DataTableHeader[];
  rows: any[];
};

export type FilterType = {
  installmentAmount: string;
  startDate: string;
  planType?: string;
};

export type TState = {
  isShowingConfirmButton: boolean;
  isShowingInstallmentAmountError: string;
  table: TableDataTypes;
  filter: FilterType;
};

export enum TActionType {
  IsShowingConfirmButton,
  IsShowingInstallmentAmountError,
  TableData,
  Filter,
}

export type IsShowingConfirmButton = {
  type: TActionType.IsShowingConfirmButton;
  payload: boolean;
};

export type IsShowingInstallmentAmountError = {
  type: TActionType.IsShowingInstallmentAmountError;
  payload: string;
};

export type TableData = {
  type: TActionType.TableData;
  payload: TableDataTypes;
};

export type Filter = {
  type: TActionType.Filter;
  payload: FilterType;
};

export type TAction = IsShowingConfirmButton | IsShowingInstallmentAmountError | TableData | Filter;
